// Shared table row/cell classes matching the original users-table design.
export const rowClass =
    'tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group even:tw-bg-gray-50/50 hover:tw-bg-primary-50/60 tw-duration-100';

export const cellClass = 'tw-px-5 tw-py-3 tw-text-sm';

export default { rowClass, cellClass };
